<template>
    <div class="pa-4">
        <v-data-table
            :headers="headers"
            :items="filteredItems"
            sort-by="sort_no"
            class="elevation-1"
            :search="search"
            :items-per-page="-1">
            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title>Variant Status & Sort</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <div class="row">
                        <div class="col-md-3">
                            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
                        </div>
                        <div class="col-md-3">
                            <v-select outlined dense hide-details="auto" :items="bottles" item-value="code" item-text="description" v-model="selectedBottle"></v-select>
                        </div>
                        
                    </div>
                    <v-spacer></v-spacer>
                </v-toolbar>

                <v-dialog v-model="dialog" v-if="dialog" width="600">
                    <v-card>
                        <v-card-title><span class="text-h5">Edit Variant Sort</span></v-card-title>
                        <v-divider />
                        <v-card-text>
                            <v-container>
                                <v-form ref="form" v-model="valid" lazy-validation>
                                    <v-row>
                                        <v-col cols="12">
                                            <span>Code</span>
                                            <v-text-field v-model="editedItem.code" filled dense hide-details="auto" disabled />
                                        </v-col>
                                        <v-col cols="12">
                                            <span>Nama Variant</span>
                                            <v-text-field v-model="editedItem.name" filled dense hide-details="auto" disabled />
                                        </v-col>
                                        <v-col cols="6">
                                            <span>No Urut</span>
                                            <v-text-field type="number" v-model="editedItem.sort_no" filled dense hide-details="auto" />
                                        </v-col>
                                        <v-col cols="6">
                                            <span>Status</span>
                                            <v-select outlined dense hide-details="auto" v-model="editedItem.is_active"
                                                :items="[
                                                    { text: 'ACTIVE', value: true },
                                                    { text: 'NO ACTIVE', value: false }
                                                ]"
                                                item-text="text"
                                                item-value="value">
                                            </v-select>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-container>
                        </v-card-text>
                        <v-divider />
                        <v-card-actions>
                            <v-spacer />
                            <v-btn color="blue darken-1" text @click="close">
                                Cancel
                            </v-btn>
                            <v-btn color="blue darken-1" text @click="save">
                                Save
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <v-dialog v-model="dialogDetail" width="600">
                    <v-card>
                        <v-card-title><span class="text-h5">Detail Variant</span></v-card-title>
                        <v-divider />
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12">
                                        <span class="font-weight-bold">Code</span>
                                        <v-text-field v-model="viewedItem.code" filled dense hide-details="auto" readonly />
                                    </v-col>
                                    <v-col cols="12">
                                        <span class="font-weight-bold">Nama Variant</span>
                                        <v-text-field v-model="viewedItem.name" filled dense hide-details="auto" readonly />
                                    </v-col>
                                    <v-col cols="6">
                                        <span class="font-weight-bold">No Urut</span>
                                        <v-text-field v-model="viewedItem.sort_no" filled dense hide-details="auto" readonly />
                                    </v-col>
                                    <v-col cols="6">
                                        <span class="font-weight-bold">Status</span>
                                        <div class="mt-2">
                                            <v-chip v-if="viewedItem.is_active" small color="green" outlined>ACTIVE</v-chip>
                                            <v-chip v-else small color="red" outlined>NO ACTIVE</v-chip>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-divider />
                        <v-card-actions>
                            <v-spacer />
                            <v-btn color="blue darken-1" text @click="closeDetail">
                                Close
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </template>
            <template v-slot:[`item.is_active`]="{ item }">
                <v-chip v-if="item.is_active" class="ma-2" small color="green" outlined>ACTIVE</v-chip>
                <v-chip v-else class="ma-2" small color="red" outlined>NO ACTIVE</v-chip>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-icon small class="mr-2" @click="viewDetail(item)">
                    mdi-eye
                </v-icon>
                <v-icon small class="mr-2" @click="editItem(item)" v-if="$store.state.currentPagePriv.update">
                    mdi-pencil
                </v-icon>
            </template>
        </v-data-table>
    </div>
</template>

<script>
    export default {
        data: () => ({
            headers: [
                { text: 'Code', value: 'code' },
                { text: 'Nama Variant', value: 'name' },
                { text: 'Status', value: 'is_active', sortable: false },
                { text: 'No Urut', value: 'sort_no' },
                { text: 'Actions', value: 'actions', sortable: false },
            ],
            items: [],
            search: '',
            bottles: [],
            selectedBottle: '490',
            dialog: false,
            dialogDetail: false,
            editedIndex: -1,
            editedItem: {},
            defaultItem: {},
            viewedItem: {},
            valid: true,
        }),

        created() {
            this.getBottles();
            this.initialize();
        },

        computed: {
            filteredItems() {
                return this.items.filter((item) => item.size === this.selectedBottle);
            }
        },

        methods: {
            async initialize() {
                let response = await this.$store.dispatch('variant/getObjs');
                if (response.data.status == 'success') {
                    this.items = response.data.data;
                }
            },
            getBottles() {
                let dataMiscCodes = this.$store.state.misccode.objs;
                this.bottles = dataMiscCodes.filter((i => i.type.includes('Botol')))
                    .sort((a,b) => {
                        return parseInt(a.code) - parseInt(b.code)
                    });
            },
            viewDetail(item) {
                this.viewedItem = Object.assign({}, item);
                this.dialogDetail = true;
            },
            closeDetail() {
                this.dialogDetail = false;
                this.$nextTick(() => {
                    this.viewedItem = {};
                });
            },
            editItem(item) {
                this.editedIndex = this.filteredItems.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            },
            close() {
                this.dialog = false;
                this.$nextTick(() => {
                    this.editedIndex = -1;
                    this.editedItem = Object.assign({}, this.defaultItem);
                })
            },
            async save() {
                await this.$refs.form.validate();
                if (!this.valid) return;

                const payload = {
                    code: this.editedItem.code,
                    name: this.editedItem.name,
                    sort_no: this.editedItem.sort_no,
                    is_active: this.editedItem.is_active ? 1 : 0,
                }
                console.log('payload', payload);

                try {
                    let url = this.$store.state.config.apiHost + "variants/" + this.editedItem.code;
                    let response = await this.$axios.put(url, JSON.stringify(payload), {headers:{'Authorization': 'Bearer '+ this.$store.state.token, 'Content-Type': 'application/json'}});
                    if (response.data.status == 'success') {
                        this.initialize();
                    }
                    this.close();
                } catch (err) {
                    return this.$store.commit('setSnackbar', {saveError: true, errorMessage: err.response.data.message})
                }
            }
        }
    }
</script>